import { ReactElement, useState } from 'react';
import './index.scss';
import editIcon from '../../assets/icons/game-edit-icon.svg';
import deleteIcon from '../../assets/icons/game-delete-icon.svg';
import { IAccordionProps, IElementsSubAccordion, INewElementAccordionProps, ISubAccordionProps } from '../../interfaces/accordion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/pro-duotone-svg-icons';
import { Tooltip } from "@progress/kendo-react-tooltip";

//Accordion code taken and modified from https://codepen.io/davidmunro/pen/xxxeoOo

export const Accordion = (props: IAccordionProps): ReactElement => {
    const [isOpen, setOpen] = useState(true);
    let textToBeDisplayed = `${props.title}`;

    if (props.count != null && props.count !== '') {
        textToBeDisplayed = `${textToBeDisplayed} (${props.count})`;
    }

    return <div className="accordion-wrapper">
        <div className='accordion-header'>
            <div className={`accordion-icon ${!isOpen ? "open" : ""}`} onClick={() => setOpen(!isOpen)} />
            <div className={`accordion-title ${isOpen ? "open" : ""}`} onClick={() => setOpen(!isOpen)}>
                <span>{textToBeDisplayed}</span>
                {props.icon != null && props.icon !== "" &&
                    <div className='accordion-title-icon'>
                        <img src={props.icon} alt='' />
                    </div>
                }
            </div>
        </div>
        <div className={`accordion-item ${!isOpen ? "collapsed" : ""}`}>
            <div className="accordion-content">{props.content}</div>
        </div>
    </div>
}

export const SubAccordion = (props: ISubAccordionProps): ReactElement => {
    return <div className="sub-accordion-wrapper">
        <div className="accordion-wrapper">
            <div className='accordion-header'>
                <div className={`accordion-title`}>
                    {props.title}
                    <Tooltip anchorElement="pointer" className='tooltip-custom'>
                        <div className='accordion-modification-options'>
                            <FontAwesomeIcon icon={faEye} title={"View element details"} onClick={() => props.onViewButtonClick()} />
                        </div>
                    </Tooltip>
                    {props.icon != null && props.icon !== "" &&
                        <div className='accordion-title-icon'>
                            <img src={props.icon} alt='' />
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}

export const NewElementAccordion = (props: INewElementAccordionProps): ReactElement => {
    const [isOpen, setOpen] = useState(true);

    return <div className={`new-element-accordion-wrapper ${isOpen ? "open" : ""}`}>
        <div className='new-element-accordion-header'>
            <div className={`new-element-accordion-title ${isOpen ? "open" : ""}`} onClick={() => setOpen(!isOpen)}>
                {props.title}
            </div>
            <div className={`new-element-accordion-icon ${!isOpen ? "open-right" : ""}`} onClick={() => setOpen(!isOpen)} />
        </div>
        <div className={`new-element-accordion-item ${!isOpen ? "collapsed" : ""}`}>
            <div className="new-element-accordion-content">{props.content}</div>
        </div>
    </div>
}

export const ElementsSubAccordion = (props: IElementsSubAccordion): ReactElement => {
    return <div className={`sub-accordion-wrapper`}>
        <div className="accordion-wrapper">
            <div className='accordion-header'>
                <div className={`accordion-title`}>
                    {props.title}
                    <div className={`accordion-modification-options ${props.isDisabled === true ? `disabled` : ``}`}>
                        <img src={editIcon} alt='' onClick={() => props.onEditButtonClick()} />
                        <img src={deleteIcon} alt='' onClick={() => props.onDeleteButtonClick()} />
                    </div>
                    {props.icon != null && props.icon !== "" &&
                        <div className='accordion-title-icon'>
                            <img src={props.icon} alt='' />
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}